import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-sso-buttons',
  templateUrl: './sso-buttons.component.html',
  styleUrls: ['./sso-buttons.component.scss'],
  standalone: true,
  imports: [IonicModule, CommonModule, TranslateModule]
})
export class SsoButtonsComponent {
  @Output() ssoLogin = new EventEmitter<'Google' | 'Apple'>();
  @Output() continueWithEmail = new EventEmitter<void>();
  @Output() continueWithPhone = new EventEmitter<void>();
  @Output() continueWithEmailAndPhone = new EventEmitter<void>();
  @Input({required: true}) emailBtnText: string = 'Continue with Email';
  @Input({required: true}) isLoginModal: boolean = false;

  onSsoLogin(provider: 'Google' | 'Apple') {
    this.ssoLogin.emit(provider);
  }

  onContinueWithEmail() {
    this.continueWithEmail.emit();
  }

  onContinueWithPhone() {
    this.continueWithPhone.emit();
  }

  onContinueWithEmailAndPhone() {
    this.continueWithEmailAndPhone.emit();
  }
}
